import { IMapCenter } from 'src/share/types/common';

export interface IRecentCase {
  caseId: string;
  childName: string;
  age: number;
  location: string;
  missingDate: number;
  center: IMapCenter;
  contactInformation: string;
}

export interface IGDStats {
  alertsIssued: number;
  alertsByCountry: { [country: string]: number };
  latestCases: number;
  latestAlerts: number;
  casesByCountry: { [country: string]: number };
  casesByWeek: Array<{ name: string; count: number }>;
  closedPercentage: string;
  casesWithAlerts: number;
  closedNumber: number;
  recentCases: IRecentCase[];
  engagedPeople: number;
  impressions: number;
  lastHoursUpdate: number;
}

export const initialGDStats: IGDStats = {
  alertsIssued: 0,
  alertsByCountry: {},
  latestCases: 0,
  latestAlerts: 0,
  casesWithAlerts: 0,
  casesByCountry: {},
  casesByWeek: [],
  closedPercentage: '0',
  closedNumber: 0,
  recentCases: [],
  engagedPeople: 0,
  impressions: 0,
  lastHoursUpdate: 0,
};
